export default "<!-- Root router-outlet -->\r\n<router-outlet id=\"app-outlet\"></router-outlet>\r\n"